'use client';

import { memo, useMemo } from 'react';

import { Tooltip, type TooltipProps } from '@air/primitive-tooltip';

export type TooltipWithShortcutProps = TooltipProps & {
  shortcut?: string[];
};

export const TooltipWithShortcut = memo(({ shortcut, label, ...restOfProps }: TooltipWithShortcutProps) => {
  const composedLabel = useMemo(() => {
    if (!label && !shortcut) {
      return undefined;
    }

    if (label && !shortcut) {
      return label;
    }

    const shortcutBadges = (
      <span className="inline-flex shrink-0 items-center gap-0.5">
        {shortcut?.map((key) => (
          <kbd
            className="flex min-w-4 items-center justify-center rounded-2 bg-white/20 px-1 text-10 text-white/70"
            key={key}
          >
            {key}
          </kbd>
        ))}
      </span>
    );

    if (!label && shortcut) {
      return shortcutBadges;
    }

    return (
      <span className="flex items-center gap-2">
        {label}
        {shortcutBadges}
      </span>
    );
  }, [label, shortcut]);

  return <Tooltip label={composedLabel} {...restOfProps} />;
});

TooltipWithShortcut.displayName = 'TooltipWithShortcut';
